import { generatePath } from 'react-router';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import Auth from '@Services/Auth';
import RxSocket from '@Services/RxSocket';

export function _goToQuickSearch() {
  if (Auth.getAccessToken()) {
    history.push(paths.SEARCH);
  }
}

export function _goToAdvancedSearch(state) {
  history.push({
    pathname: paths.ADVANCED,
    state: { ...state },
  });
}

export function _resolveAuth(callback) {
  // eslint-disable-next-line consistent-return
  return async (...args) => {
    if (!Auth.isAnonymousUser()) {
      return callback(...args);
    }

    try {
      await RxSocket.getDelayedConnectPromise();
      history.push({
        pathname: generatePath(paths.LOGIN),
      });
    } catch (e) {
      Logger.error(e);
    }
  };
}
